<template>
    <div id="haierProduct">
        <Header @loaded="changeLoading" />
        <router-view v-if="loaded && loadNum > 0" :style="{minHeight:minHeight+'px'}" />
        <Footer class="mt20" v-if="$route.name!='home'&&isShow" />
    </div>
</template>
<script>
    import Header from '@/components/common/WebHeader'
    import Footer from '@/components/common/Footer'
    export default {
        name: 'HaierProduct',
        components: { Header, Footer },
        data () {
            return {
                minHeight: window.innerHeight - 214,
                loaded: false,
                loadNum: 0,
                isShow: true
            }
        },
        created () {
            window.vue = this;
            if (this.$route.query.token) {
                this.sso()
            } else {
                this.loaded = true;
            }
            if (this.$route.query.from && this.$route.query.from == 'share') {
                this.isShow = false
            }
        },
        methods: {
            changeLoading(){
                this.loadNum++;
            },
            /**
             * 第三方单点登录
             */
            sso () {
                this.$axios.post("/thirdChannel/authentication", {
                    channelId: "3v7zdjaEOlrw4y9J", //生产渠道id
                    token: this.$route.query.token
                }).then(res => {
                    this.$store.commit('setUserInfoAll', res);
                    this.loaded = true;
                    let url = vue.$route.fullPath.replace(/\?token=.*$/, '');
                    this.$router.replace(url)
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/HaierProduct.vue